import { sortBy } from 'lodash';
import {
  CalculsFormCalendrierDeficitFonctionnelTemporairePartiel,
  CalculsGlobal,
} from 'src/constants/calculs';
import { prejudiceBaseDefaultValues } from 'src/constants/prejudice/defaultValues';
import {
  DFTPRowType,
  PrejudiceFormCalendrierDeficitFonctionnelTemporairePartiel,
  PrejudiceFormCalendrierDeficitFonctionnelTemporairePartielRow,
} from 'src/types/prejudice.type';
import { Procedure } from 'src/types/procedure.type';

export type DFTPRowExistingValues =
  Partial<PrejudiceFormCalendrierDeficitFonctionnelTemporairePartielRow>;
export type DFTPExistingValues = Omit<
  Partial<PrejudiceFormCalendrierDeficitFonctionnelTemporairePartiel>,
  'rows'
> & {
  rows?: DFTPRowExistingValues[];
};

export const getCalendrierDeficitFonctionnelTemporairePartielRowDefaultValues =
  (
    values: DFTPExistingValues | undefined,
    existingRowValues: DFTPRowExistingValues | undefined,
    type: DFTPRowType,
  ): PrejudiceFormCalendrierDeficitFonctionnelTemporairePartielRow => {
    const dateDebut = existingRowValues?.dateDebut ?? null;
    const dateFin = existingRowValues?.dateFin ?? null;
    const joursHospitalisationADeduire =
      existingRowValues?.joursHospitalisationADeduire || 0;
    const deduireJoursHospitalisation =
      existingRowValues?.deduireJoursHospitalisation ?? false;
    const joursPeriode =
      dateDebut && dateFin ? CalculsGlobal.getDays(dateDebut, dateFin) : 0;
    const totalJours = CalculsGlobal.max([0, joursPeriode]);
    const percentage = existingRowValues?.percentage ?? null;
    const forfaitJour =
      existingRowValues?.forfaitJour || values?.forfaitJour || 0;
    const montantTotal =
      CalculsFormCalendrierDeficitFonctionnelTemporairePartiel.montantTotal({
        totalJours,
        percentage: percentage || 0,
        forfaitJour,
      });
    const commentaires = existingRowValues?.commentaires ?? null;
    const numerosPieces = existingRowValues?.numerosPieces ?? { rows: [] };
    return {
      dateDebut,
      dateFin,
      joursHospitalisationADeduire,
      deduireJoursHospitalisation,
      joursPeriode,
      totalJours,
      percentage,
      forfaitJour,
      montantTotal,
      commentaires,
      numerosPieces,
      type,
    };
  };
export const calendrierDeficitFonctionnelTemporairePartielDefaultValues = ({
  values,
  procedure,
  isExtractedValues,
}: {
  values: DFTPExistingValues | undefined;
  procedure: Procedure;
  isExtractedValues: boolean;
}): PrejudiceFormCalendrierDeficitFonctionnelTemporairePartiel => {
  const baseValues = prejudiceBaseDefaultValues({
    values,
  });
  const notes = values?.notes || '';
  const forfaitJour =
    (values && !isExtractedValues
      ? values?.forfaitJour
      : procedure.baremes?.forfaitJourDFTP) ?? 0;
  const existingValues: DFTPExistingValues = {
    ...baseValues,
    notes,
    forfaitJour,
  };
  const rows =
    sortBy(values?.rows, (row) => row.dateDebut)?.map((row) => {
      const defaultRowType: DFTPRowType = row.commentaires
        ? 'autreComposante'
        : 'dftp';
      return {
        ...getCalendrierDeficitFonctionnelTemporairePartielRowDefaultValues(
          existingValues,
          row,
          row.type ?? defaultRowType,
        ),
        ...row,
      };
    }) || [];
  const total =
    CalculsFormCalendrierDeficitFonctionnelTemporairePartiel.total(rows) || 0;
  return {
    ...baseValues,
    forfaitJour,
    notes,
    rows,
    total,
  };
};
